// src/IT/components/StatusPill.jsx
// Thin wrapper — real implementation in shared/ui/StatusBadge.jsx
// (map: "it", see shared/ui/statusMaps.js's `itRequestStatusMap`).
// Still renders the `it-pill it-{status}` class so it.css's existing
// hand-written styling keeps applying unchanged.
import StatusBadge from "../../shared/ui/StatusBadge";

export default function StatusPill({ status }) {
  return <StatusBadge map="it" status={String(status || "").toLowerCase()} />;
}
